import { RouteRecordRaw } from 'vue-router'

// 课程学习模块路由
const courseStudyRoutes: RouteRecordRaw = {
  path: '/courses',
  name: 'CourseStudy',
  component: () => import('@/views/CourseStudy/index.vue'),
  meta: {
    title: '课程学习',
    icon: 'Reading',
    keepAlive: true,
    requiresAuth: true,
  },
  children: [
    // 默认重定向到课程列表
    {
      path: '',
      name: 'CourseList',
      component: () => import('@/views/CourseStudy/CourseList.vue'),
      meta: {
        title: '课程列表',
        keepAlive: true,
        requiresAuth: true,
      },
    },
    // 录播课程详情
    {
      path: 'recorded/:id',
      name: 'RecordedCourseDetail',
      component: () => import('@/views/CourseStudy/RecordedCourse/RecordedCourseDetail.vue'),
      meta: {
        title: '录播课程详情',
        keepAlive: false,
        requiresAuth: true,
      },
    },
    // 录播课程学习页面
    {
      path: 'recorded/learning/:id',
      name: 'RecordedCourseLearning',
      component: () => import('@/views/CourseStudy/RecordedCourse/RecordedCourseLearning.vue'),
      meta: {
        title: '录播课程学习',
        keepAlive: false,
        requiresAuth: true,
      },
    },
    // 直播课程详情
    {
      path: 'live/:id',
      name: 'LiveCourseDetail',
      component: () => import('@/views/CourseStudy/LiveCourse/LiveCourseDetail.vue'),
      meta: {
        title: '直播课程详情',
        keepAlive: false,
        requiresAuth: true,
      },
    },
    // 直播课表
    {
      path: 'live/schedule',
      name: 'LiveCourseSchedule',
      component: () => import('@/views/CourseStudy/LiveCourse/LiveCourseSchedule.vue'),
      meta: {
        title: '直播课表',
        keepAlive: true,
        requiresAuth: true,
      },
    },
    // 直播回放
    {
      path: 'live/playback/:id',
      name: 'LiveCoursePlayback',
      component: () => import('@/views/CourseStudy/LiveCourse/LiveCoursePlayback.vue'),
      meta: {
        title: '直播回放',
        keepAlive: false,
        requiresAuth: true,
      },
    },
    // 直播预约
    {
      path: 'live/reservation/:id',
      name: 'LiveCourseReservation',
      component: () => import('@/views/CourseStudy/LiveCourse/LiveCourseReservation.vue'),
      meta: {
        title: '直播预约',
        keepAlive: false,
        requiresAuth: true,
      },
    },
    // 直播间
    {
      path: 'live/room/:id',
      name: 'LiveCourseRoom',
      component: () => import('@/views/CourseStudy/LiveCourse/LiveCourseRoom.vue'),
      meta: {
        title: '直播间',
        keepAlive: false,
        requiresAuth: true,
      },
    },
    // 学习进度
    {
      path: 'progress',
      name: 'LearningProgress',
      component: () => import('@/views/CourseStudy/LearningProgress.vue'),
      meta: {
        title: '学习进度',
        keepAlive: true,
        requiresAuth: true,
      },
    },
  ],
}

export default courseStudyRoutes 